// extracted by mini-css-extract-plugin
export default {"your_rd":"eu","title":"fu","subtitle":"gu","rd_bio_wrapper":"hu","rd_text_mobile":"iu","rd_bio":"ju","img":"ku","rd_info":"lu","rd_name":"mu","rd_stat":"nu","rd_text":"ou","btn_mobile":"pu"};
    if(module.hot) {
      // 1711394576146
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  